import { type Asset } from '@/services/db/asset/entity';

export function canDeleteAsset(asset: Asset): boolean {
  return !(asset.is_dir && asset.size > 0);
}

export function getDeleteBlockedReason(asset: Asset): string | undefined {
  if (asset.is_dir && asset.size > 0) {
    return 'This folder cannot be deleted with assets inside.';
  }
  return undefined;
}
